import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { secondary } from 'styles/colors'
import {
  updateUserInfo,
  updateConsultantInterests,
  createExperience,
  completeOnboarding,
} from 'actions'

import {
  Form,
  FormContainer,
  Field,
  Label,
  RolesInput,
  InterestsInput,
  InputWithSuggestions,
  DescriptionInput,
  Input,
  AvailabilityInput,
  Checkbox,
} from 'components/form'
import ButtonGroup from 'components/ButtonGroup'
import Button from 'components/Button'

const Wrapper = styled.div`
  background-color: ${secondary};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

class Onboarding extends React.Component {
  state = {
    step: 0,
    roles: [],
    interests: [],
    customer: '',
    duration: '',
    description: '',
    availability: {},
    hasNoExperience: false,
  }

  submit = e => {
    e.preventDefault()
    this.saveRolesAndInterests();
    if (!this.state.hasNoExperience && (
      this.state.customer ||
      this.state.duration ||
      this.state.description)
    ) {
      this.props.createExperience(this.props.consultantId, {
        type: 'work',
        customer: this.state.customer,
        duration: this.state.duration,
        description: this.state.description,
      })
    }
    this.props.completeOnboarding()
  }

  saveRolesAndInterests() {
    if (this.state.roles.length > 0 || this.state.availability) {
      this.props.updateUserInfo(this.props.consultantId, {
        titles: this.state.roles,
        dateOfBirth: this.state.dateOfBirth,
        mobile: this.state.mobile,
        availability: {
          ...this.state.availability,
          date:
            this.state.availability.date &&
              this.state.availability.type === 'date'
              ? this.state.availability.date.format('YYYY-MM-DD')
              : '',
          value:
            this.state.availability.type === 'other'
              ? this.state.availability.value
              : '',
        },
      })
    }
    if (this.state.interests.length > 0) {
      this.props.updateConsultantInterests(
        this.props.consultantId,
        this.state.interests
      )
    }
  }

  render() {
    return (
      <Wrapper>
        {this.state.step === 0 ? (
          <FormContainer title="Kort om meg">
            <Form>
              <Field>
                <Label htmlFor="interests">Hva er du flink til?</Label>
                <InterestsInput
                  id="interests"
                  value={this.state.interests}
                  helpText="Skriv minst en ting du er flink til."
                  onChange={interests => this.setState({ interests })}
                />
              </Field>
              <Field>
                <Label htmlFor="roles">Hva har du lyst til å jobbe med?</Label>
                <RolesInput
                  id="roles"
                  helpText="Skriv minst én ting du har lyst til å jobbe med."
                  value={this.state.roles}
                  onChange={roles => this.setState({ roles })}
                />
              </Field>

              <Field>
                <Label htmlFor="availability">
                  Når kan du jobbe?
                </Label>
                <AvailabilityInput
                  id="availability"
                  value={this.state.availability}
                  onChange={availability => this.setState({ availability })}
                />
              </Field>
              <Field>
                <Label htmlFor="dateOfBirth">
                  Hva er fødselsdatoen din?
                </Label>
                <Input
                  type="text"
                  id="dateOfBirth"
                  placeholder="F.eks. 15.02.2003"
                  value={this.state.dateOfBirth}
                  onChange={e => this.setState({ dateOfBirth: e.target.value })}
                />
              </Field>
              <Field>
                <Label htmlFor="mobile">
                  Hva er mobilnummeret ditt?
                </Label>
                <Input
                  type="text"
                  id="mobile"
                  placeholder="F.eks. 00 00 00 00"
                  value={this.state.mobile}
                  onChange={e => this.setState({ mobile: e.target.value })}
                />
              </Field>
              <Button type="submit" onClick={() => this.setState({ step: 1 })}>
                Neste
              </Button>
            </Form>
          </FormContainer>
        ) : (
            <FormContainer title="Siste jobben jeg hadde">
              <Form onSubmit={this.submit}>
                {this.state.hasNoExperience ? null : <React.Fragment>
                  <Field>
                    <Label htmlFor="customer">Hvem jobbet du for?</Label>
                    <InputWithSuggestions
                      id="customer"
                      suggestionsType="customer"
                      value={this.state.customer}
                      placeholder="F.eks. Aftenposten"
                      onChange={e => this.setState({ customer: e.target.value })}
                    />
                  </Field>
                  <Field>
                    <Label htmlFor="duration">Ca lengde på jobben?</Label>
                    <Input
                      type="text"
                      id="duration"
                      placeholder="F.eks. 3 uker"
                      value={this.state.duration}
                      onChange={e => this.setState({ duration: e.target.value })}
                    />
                  </Field>
                  <Field>
                    <Label htmlFor="description">Hva gjorde du</Label>
                    <DescriptionInput
                      id="description"
                      value={this.state.description}
                      onChange={e => this.setState({ description: e.target.value })}
                      placeholder="F.eks. Gikk med avisen, Luftet hunden for naboen, Jobbet i barnehage"
                    />
                  </Field>
                </React.Fragment>
                }
                <Field>
                  <Checkbox
                    id="hasNoExperience"
                    checked={this.state.hasNoExperience}
                    onChange={e =>
                      this.setState({
                        hasNoExperience: e.target.checked,
                      })
                    }
                  />
                  <Label htmlFor="hasNoExperience">
                    Jeg har ikke arbeidserfaring
                </Label>
                </Field>
                <ButtonGroup>
                  <Button
                    secondary
                    type="button"
                    onClick={() => this.setState({ step: 0 })}>
                    Tilbake
                </Button>
                  <Button type="submit">Fullfør</Button>
                </ButtonGroup>
              </Form>
            </FormContainer>
          )}
      </Wrapper>
    )
  }
}

const mapStateToProps = state => ({
  consultantId: state.auth.user.id,
})

const mapDispatchToProps = {
  updateUserInfo,
  updateConsultantInterests,
  createExperience,
  completeOnboarding,
}

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding)



// WEBPACK FOOTER //
// ./src/pages/Onboarding.js